import React, { PureComponent } from 'react'
import {
  Image, Container, Title, NewButton,
} from './styled'
import './stylecss.css'
import Banner from '../../images/ks-banner.png'

const HomeContainer = () => (
  <Container>
    <Image src={Banner} />
    <Title>
      Start your next react project in seconds
    </Title>
  </Container>
)

export default HomeContainer



// WEBPACK FOOTER //
// ./src/components/home/index.jsx